import React from 'react';
import { makeStyles } from '@material-ui/core';
import PropTypes from 'prop-types';
import PeriodStartDateSelector from '~/modules/common/charts/dashboard/PeriodStartDateSelector';
import { StickyHeader } from '~/modules/common/components';
import { useIsBreakpointDown } from '~/modules/common/hooks';
import { useMeContext } from '~/modules/me/useMeContext';
import { useProjectContext } from '~/modules/resourcing/common/contexts';
import {
  ResourcingActualToggleButton,
  ResourcingDisplayUnitToggleButtonGroup,
  ResourcingLegends,
  ResourcingPeriodDropDown
} from '~/modules/resourcing/common/components';
import { PERIOD_SCALE_ENUM } from '~/modules/resourcing/common/enums';
import { PROJECT_PERMISSION } from '~/modules/common/enums';
import { useResourcingChartToolbarContext } from '../../hooks';
import ResourceRequestImportExportMenu from '../ResourceRequestImportExportMenu';
import ProjectSettingsButton from '../ProjectSettings';

const useLegendStyles = makeStyles(() => ({
  root: {
    width: '100%'
  }
}));

const useStyles = makeStyles(theme => ({
  spacer: {
    flexGrow: 1,
    flexShrink: 1,
    padding: theme.spacing(0, 1)
  }
}));

export const ResourceRequestToolbar = ({ classes: classesOverride }) => {
  const {
    displayUnit,
    setDisplayUnit,
    scale,
    dateRange,
    setScale,
    onPrevious,
    onNext,
    isResourceActualModeEnabled,
    setIsResourceActualModeEnabled,
    legends,
    setDate
  } = useResourcingChartToolbarContext();

  const {
    featureFlags: {
      isPSAQuickAllocationDemandEnabled,
      isPsaPrpWhenAddingTeamMembersEnabled
    }
  } = useMeContext();
  const legendClasses = useLegendStyles();
  const classes = useStyles({ classes: classesOverride });

  const isMobile = useIsBreakpointDown('sm');

  const { project } = useProjectContext();
  const canEditProject = Boolean(
    project?.permittedActionUris?.includes(PROJECT_PERMISSION.EDIT_PROJECT)
  );

  return (
    <StickyHeader level={3}>
      {scale !== PERIOD_SCALE_ENUM.OVERVIEW && (
        <PeriodStartDateSelector
          onPreviousClick={onPrevious}
          onNextClick={onNext}
          dateRange={dateRange}
          scale={scale}
          setDate={setDate}
        />
      )}
      <div className={classes.spacer} />
      <ResourcingLegends
        legends={legends}
        classes={legendClasses}
        showNewLegends
      />
      <ResourcingActualToggleButton
        isResourceActualModeEnabled={isResourceActualModeEnabled}
        setIsResourceActualModeEnabled={setIsResourceActualModeEnabled}
      />

      {scale !== PERIOD_SCALE_ENUM.OVERVIEW ? (
        <ResourcingDisplayUnitToggleButtonGroup
          displayUnit={displayUnit}
          setDisplayUnit={setDisplayUnit}
        />
      ) : null}

      <ResourcingPeriodDropDown
        scale={scale}
        setScale={setScale}
        showYears={!isPSAQuickAllocationDemandEnabled}
        data-qe-id="ResourcePeriodDropdown"
      />
      {!isMobile && <ResourceRequestImportExportMenu isMobile={isMobile} />}
      {isPsaPrpWhenAddingTeamMembersEnabled && (
        <ProjectSettingsButton
          projectId={project?.id}
          projectTeamMemberAssignmentType={
            project?.projectTeamMemberAssignmentType
          }
          canEdit={canEditProject}
        />
      )}
    </StickyHeader>
  );
};

ResourceRequestToolbar.propTypes = {
  classes: PropTypes.object
};

export default ResourceRequestToolbar;
